import React, { Component } from 'react';
import { Menu, Select } from 'antd';
import { PageContent } from '../components/guide';
import GuideTutorials from '../components/tutorial/GuideTutorials';
import { captureAnalytics } from '../actions/preload';
import '../components/guide/guide.scss';

import {
  welcomePageCopy,
  printerDriverCopy,
  adminToolsCopy,
  faqCopy,
  gettingStartedCopy,
  chromeExtensionCopy,
  UploadingCopy,
  SendingCopy,
  ReceivingCopy,
  SigningAndAnnotatingCopy,
  MergingRecordsCopy,
  AddingTaggingCopy,
  AddingCategoryCopy,
  AddingTaskTemplateCopy,
  AssigningRecordsCopy,
  AddingTaskProviderCopy,
} from '../components/guide/copy';

const { Item } = Menu;

// Sits outside the numeric copy map (1-16) so it can't collide with a future
// guide page key.
const TUTORIALS_MENU_KEY = 'interactive-tutorials';

const GUIDE_MENU_ITEMS = [
  { key: '1', label: 'Welcome to Medsender' },
  { key: '2', label: 'Getting Started' },
  { key: TUTORIALS_MENU_KEY, label: 'Interactive Tutorials' },
  { key: '3', label: 'Uploading Records' },
  { key: '4', label: 'Sending Records' },
  { key: '5', label: 'Receiving Records' },
  { key: '6', label: 'Signing/Annotating Records' },
  { key: '7', label: 'Merging Records' },
  { key: '8', label: 'Tagging/ Labeling Records' },
  { key: '15', label: 'Assigning Records (NEW)' },
  { key: '13', label: 'Managing Categories' },
  { key: '14', label: 'Managing Task Templates' },
  { key: '16', label: 'Managing Task Providers' },
  { key: '9', label: 'Chrome Extension' },
  { key: '10', label: 'Printer Driver' },
  { key: '11', label: 'Admin Tools' },
  { key: '12', label: 'FAQ' },
];

class MedsenderGuide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMenuItem: '1',
    };
  }

  selectingGuideMenuItem = (item, source = 'content') => {
    const selectedMenuItem = String(item.key);
    const selectedSection = GUIDE_MENU_ITEMS.find(({ key }) => key === selectedMenuItem);

    this.setState({ selectedMenuItem });
    captureAnalytics('guide_section_selected', {
      section: selectedSection ? selectedSection.label : 'Unknown',
      source,
    });

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  render() {
    const pageContent = {
      1: welcomePageCopy,
      2: gettingStartedCopy,
      3: UploadingCopy,
      4: SendingCopy,
      5: ReceivingCopy,
      6: SigningAndAnnotatingCopy,
      7: MergingRecordsCopy,
      8: AddingTaggingCopy,
      9: chromeExtensionCopy,
      10: printerDriverCopy,
      11: adminToolsCopy,
      12: faqCopy,
      13: AddingCategoryCopy,
      14: AddingTaskTemplateCopy,
      15: AssigningRecordsCopy,
      16: AddingTaskProviderCopy,
    };
    const { selectedMenuItem } = this.state;
    const showTutorials = selectedMenuItem === TUTORIALS_MENU_KEY;

    return (
      <div className="medsender-guide">
        <Menu
          className="medsender-guide__sidebar"
          mode="inline"
          selectedKeys={[selectedMenuItem]}
          onClick={(item) => this.selectingGuideMenuItem(item, 'sidebar')}
        >
          {GUIDE_MENU_ITEMS.map(({ key, label }) => (
            <Item key={key} className="remove-purple-highlight">{label}</Item>
          ))}
        </Menu>

        <div className="medsender-guide__main">
          <div className="medsender-guide__mobile-nav">
            <div className="medsender-guide__mobile-label" id="guide-section-label">Browse the guide</div>
            <Select
              id="guide-section-select"
              aria-labelledby="guide-section-label"
              data-testid="guide-section-select"
              value={selectedMenuItem}
              options={GUIDE_MENU_ITEMS.map(({ key, label }) => ({ value: key, label }))}
              onChange={(key) => this.selectingGuideMenuItem({ key }, 'mobile_selector')}
            />
          </div>

          {showTutorials
            ? <GuideTutorials />
            : <PageContent selectingGuideMenuItem={this.selectingGuideMenuItem} copy={pageContent[selectedMenuItem]} />}
        </div>
      </div>
    );
  }
}

export default MedsenderGuide;
